<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title
        >下载中心
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" v-show="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.fileName">
            <el-input
              v-model="slotForms.forms.fileName"
              placeholder="文件名"
              clearable
            ></el-input>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格tab -->
    <section class="g-table-tab-section table-tab-section fixed-view">
      <e6-flank-fix>
        <el-upload
          class="upload-demo"
          action="/app/file/uploadFile"
          :show-file-list="false"
          :on-success="uploadSuccess"
          :file-list="fileList"
        >
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <template slot="fixRight">
          <i
            class="flank-fix__item e6-icon-clear_line"
            @click="handleDeleteFileInfo"
          ></i>
        </template>
      </e6-flank-fix>
    </section>
    <!-- 表格tab end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          align="center"
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          label="序号"
          width="50"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column label="文件名" fixed prop="fileName"></el-table-column>
        <el-table-column
          label="上传时间"
          fixed
          prop="createdTime"
        ></el-table-column>
        <el-table-column
          align="center"
          fixed="right"
          :label="$t('_private.button.operate')"
          width="80"
        >
          <template slot-scope="scope">
            <el-button type="text" round @click="DownloadFile(scope.row)"
              >下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 批量删除确认 -->
    <e6-message-box
      :messageBoxVisible.sync="messageBoxVisible"
      @messageBoxSubmit="handleMessageBoxSubmit"
    >
      <div class="batch-delete">确定删除所选数据？</div>
    </e6-message-box>
    <!-- 批量删除确认 end -->
  </div>
</template>

<script>
import {
  DeleteFileInfo,
  FetchByPage,
  SaveDownloadFileInfo
} from "@/api/systemSetting/downloadCenter";
import { DownloadFile } from "@/api/buttJointCenter/interfaceDocumentCenter";
import { mapGetters } from "vuex";
import resizeListener from "_private/mixins/resizeListener";
import { mergeFormExtend } from "_private/utils/merge";

export default {
  mixins: [resizeListener],
  data() {
    return {
      total: 0,
      curPage: 1,
      pageSize: 20,
      isSearch: true,
      formExtend: {
        forms: {},
        extends: []
      },
      tableData: [],
      multipleSelection: [],
      messageBoxVisible: false,
      fileList: [],
      url: "/app/file/download?fileName="
    };
  },
  computed: {
    ...mapGetters(["moduleId", "userId"]),
    ids() {
      let ids = this.multipleSelection.map(item => {
        return item.id;
      });
      return ids.length < 1 ? "" : ids.join(",");
    }
  },
  created() {
    this.FetchByPage(this.mergeObj());
  },
  methods: {
    // 获取表格数据
    FetchByPage(data) {
      FetchByPage(data)
        .then(response => {
          if (
            response.result &&
            response.result.data &&
            Array.isArray(response.result.data)
          ) {
            this.tableData = response.result.data;
            this.total = response.result.totalRecords;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    uploadSuccess(response, files, fileList) {
      let fileNames = response.result.fileName;
      let fileNameActive = response.result.fileNameActive;
      this.SaveDownloadFileInfo({
        fileName: fileNames,
        fileNameActive: fileNameActive
      });
    },
    // 新增文件
    SaveDownloadFileInfo(data) {
      SaveDownloadFileInfo(data)
        .then(response => {
          this.submitCallback(response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    //下载文件
    DownloadFile(row) {
      DownloadFile({ fileName: row.fileNameActive })
        .then(response => {
          this.exportXlsx(response, `${row.fileNameActive}`);
          this.$message.success("下载成功");
        })
        .catch(error => {
          console.log(error);
        });
    },
    exportXlsx(data, name) {
      const blob = new Blob([data]);
      const fileName = name; //下载文件名称
      const eLink = document.createElement("a");
      eLink.download = fileName;
      eLink.style.display = "none";
      eLink.href = URL.createObjectURL(blob);
      document.body.appendChild(eLink);
      eLink.click();
      URL.revokeObjectURL(eLink.href); // 释放URL 对象
      document.body.removeChild(eLink);
    },
    // 删除
    DeleteFileInfo(data) {
      DeleteFileInfo(data)
        .then(response => {
          this.submitCallback(response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        moduleId: this.moduleId,
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize
        }
      });
    },
    submitCallback(data) {
      let type = data.code === 1 ? "success" : "error";
      let message = data.message;
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 2000,
        onClose: () => {
          if (type === "success") {
            this.FetchByPage(this.mergeObj());
          }
        }
      });
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.FetchByPage(this.mergeObj());
    },
    handleResetForm() {
      this.$refs.selectTree.handleclear();
    },
    // 表格选择改变事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.FetchByPage(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.FetchByPage(this.mergeObj());
    },
    // 打开确认删除面板
    handleDeleteFileInfo() {
      if (this.ids === "") {
        return this.$message({
          showClose: true,
          message: "至少选择一条数据",
          type: "error",
          duration: 1200
        });
      }
      this.messageBoxVisible = true;
    },
    // 确认删除
    handleMessageBoxSubmit() {
      this.DeleteFileInfo({ ids: this.ids });
    },
    handleResetForm() {
      this.formExtend.forms.appKey = null;
      this.formExtend.forms.userNickName = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}
</style>
